<template>
  <div>
    <div class="l-container">
      <h1 class="m-label">先生ファイル</h1>
      <tr-c slot="tr-th">
        <th-c>id</th-c>
        <th-c>tutor_id</th-c>
        <th-c>user_id</th-c>
        <th-c>ファイル名</th-c>
        <th-c>作成日</th-c>
      </tr-c>
      <tr-c slot="tr-td">
        <td-c>{{tutorfile.id}}</td-c>
        <td-c>{{tutorfile.tutor_id}}</td-c>
        <td-c>{{tutorfile.user_id}}</td-c>
        <td-c>{{tutorfile.file_name}}</td-c>
        <td-c>{{tutorfile.created_at}}</td-c>
      </tr-c>
    </div>
    <template v-if="tutorfile.id">
      <iframe v-bind:src="files + tutorfile.id + '_t.pdf'" frameborder="0"></iframe>
    </template>
  </div>
</template>

<script>
import { getFILE } from '@/store/getters.js'
const files = getFILE()

export default {
  computed: {
    tutorfile () {
      return this.$store.getters.tutorfile
    }
  },
  data () {
    return {
      files: files
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getTutorfile(to.params.id)
    })
  },
  methods: {
    getTutorfile (id) {
      this.$store.dispatch('getTutorfile', {
        id: id
      })
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: calc(100vh - 185px);
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// Tutorfile.vue?4e80daca